import {useEffect} from 'react';

const useRemoveMinWidthRestrictionWhileMounted = () => {
    useEffect(() => {
        const root = document.getElementById('root');
        if (!root) return undefined;

        root.style.setProperty('min-width', 'unset', 'important');

        return () => {
            root.style.setProperty('min-width', '1024px', 'important');
        };
    }, []);
};

export default useRemoveMinWidthRestrictionWhileMounted;
